import { useMemo } from 'react';

import { URLS, IMAGE_SIZE } from '@services/images/constants';
import getFullImageUrl from '@services/images/getFullImageUrl';
import useScreenWidthImage from './useScreenWidthImage';

function useProductImage({ image, size = IMAGE_SIZE.MEDIUM }) {
  const width = useScreenWidthImage({ size });

  const src = useMemo(
    () => (width ? getFullImageUrl({ url: URLS.PRODUCT, image, width }) : ''),
    [image, width],
  );

  return src;
}

export default useProductImage;
